export default "./images/survio-U7gOR-assets-custom-login-page.svg";